// extracted by mini-css-extract-plugin
module.exports = {"tabsSchema":"TabsSchema_tabsSchema__25LQc"};